import type { CapabilityControlProps } from '../../../core/types';
import { isFieldReadonly } from '../../../platform/capability-registry/fieldControl';
import { COMPUTE_FIELD_KEYS } from '../fieldKeys';
import type { ComputeModalResourceKind } from '../types';

function computeResourceFieldKey(kind: ComputeModalResourceKind): string {
  if (kind === 'cpu') return COMPUTE_FIELD_KEYS.cpu;
  if (kind === 'memory') return COMPUTE_FIELD_KEYS.memory;
  return COMPUTE_FIELD_KEYS.gpu;
}

/** CPU / 内存 / GPU 是否只读（含 preview） */
export function isComputeResourceReadonly(kind: ComputeModalResourceKind, control: CapabilityControlProps): boolean {
  return isFieldReadonly(computeResourceFieldKey(kind), control);
}
